'use strict';
import angular from 'angular';
import './scripts/notifications.ctrls';
import './scripts/notifications.services';

import notificationsHtmlUrl from './views/notifications.html';

angular.module('notifications', [
    'notifications.ctrls',
    'notifications.services'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('notificationsCurrent', {
                parent: 'layout',
                url: '/notifications',
                templateUrl: notificationsHtmlUrl,
                controller:'NotificationsController'
            })
            .state('notificationsArchived', {
                parent: 'layout',
                url: '/notifications',
                templateUrl: notificationsHtmlUrl,
                controller:'NotificationsController',
                params: {
                    archived: 'true'
                }
            })
    }]);